import React, { useContext } from 'react';
import './ConsumptionCard.css';
import { themeContext } from 'contexts/theme_context/ThemeContext';

const ConsumptionCard = ({ date, efficiency, dailyMileage }) => {
    const { webtheme } = useContext(themeContext);

    // Logic for color based on efficiency
    let color;
    let progress; // Percentage for the slider

    if (efficiency == null) {
        color = '#6C757D';
        progress = 0;
    } else if (efficiency < 120) {
        color = '#58D68D'; // Green
        progress = 100;
    } else if (efficiency < 150) {
        color = '#58D68D'; // Green
        progress = 85;
    } else if (efficiency < 180) {
        color = '#58D68D'; // Green
        progress = 70;
    } else if (efficiency < 210) {
        color = '#F4D03F'; // Yellowish
        progress = 55;
    } else if (efficiency < 240) {
        color = '#F5B041'; // Orange
        progress = 35;
    } else {
        color = '#EC7063'; // Red
        progress = 15;
    }

    return (
        <div className={`consumption-card ${webtheme}-theme`}>
            {/* Left Side: Visual Slider */}
            <div className="consumption-visual">
                <div className="slider-track">
                    <div
                        className="slider-fill"
                        style={{
                            width: `${progress}%`,
                            backgroundColor: color
                        }}
                    ></div>
                    <div
                        className="slider-thumb"
                        style={{ left: `${progress}%`, borderColor: color }}
                    >
                    </div>
                </div>
            </div>

            {/* Right Side: Data */}
            <div className="consumption-data">
                <span className="consumption-date">
                    {new Date(date).toLocaleDateString()}
                </span>
                <div className="consumption-metrics">
                    <div className="metric-row">
                        <span className="metric-value efficiency-val">{efficiency ? efficiency.toFixed(2) : '--'}</span>
                        <span className="metric-unit">wh/km</span>
                    </div>
                    {dailyMileage && (
                        <div className="metric-row">
                            <span className="metric-value mileage-val">{dailyMileage.toFixed(2)}</span>
                            <span className="metric-unit">km</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConsumptionCard;
